export const setPagebackgroundColor = (pageBackgroundColor) =>
	({
		type    : 'SET_PAGE_BACKGROUND_COLOR',
		payload : { pageBackgroundColor }

	}
	);
export const setActiveSpeakerBorderColor = (activeSpeakerBorderColor) =>
	({
		type    : 'SET_ACTIVE_SPEAKER_COLOR',
		payload : { activeSpeakerBorderColor }

	});
export const setAppToolBarColor = (appToolBarColor) =>
	({
		type    : 'SET_APP_TOOLBAR_COLOR',
		payload : { appToolBarColor }

	});
export const setChatBackgroundColor = (chatBackgroundColor) =>
	({
		type    : 'SET_CHAT_BACKGROUND_COLOR',
		payload : { chatBackgroundColor }

	});
export const setIconsColor = (iconsColor) =>
	({
		type    : 'SET_ICON_DISABLE_COLOR',
		payload : { iconsColor }

	});
export const setIconsColorEnable = (iconsColorEnable) =>
	({
		type    : 'SET_ICON_ENABLE_COLOR',
		payload : { iconsColorEnable }

	});
export const setPeerShadowColor = (peerShadowColor) =>
	({
		type    : 'SET_PEER_SHADOW_COLOR',
		payload : { peerShadowColor }

	});
export const setUserBackgroundColor = (userBackgroundColor) =>
	({
		type    : 'SET_USER_BACKGROUND_COLOR',
		payload : { userBackgroundColor }

	});
export const setUserAvator = (userAvator) =>
	({
		type    : 'SET_USER_AVATAR_COLOR',
		payload : { userAvator }

	});
